import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const LandingFAQ = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('customer');

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">{t('landing.faq.title')}</h2>
          <p className="text-xl text-muted-foreground">{t('landing.faq.subtitle')}</p>
        </div>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-8">
            <TabsTrigger value="customer" className="text-base">
              {t('landing.faq.tabs.customer')}
            </TabsTrigger>
            <TabsTrigger value="carrier" className="text-base">
              {t('landing.faq.tabs.carrier')}
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="customer" className="space-y-6">
            <Accordion type="single" collapsible className="w-full space-y-4">
              {(t('landing.faq.questions.customer', { returnObjects: true }) as Array<{question: string, answer: string}>).map((item, index) => (
                <AccordionItem key={index} value={`customer-${index}`} className="border border-border bg-background rounded-lg px-6">
                  <AccordionTrigger className="text-xl font-semibold text-foreground hover:no-underline py-6">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </TabsContent>
          
          <TabsContent value="carrier" className="space-y-6">
            <Accordion type="single" collapsible className="w-full space-y-4">
              {(t('landing.faq.questions.carrier', { returnObjects: true }) as Array<{question: string, answer: string}>).map((item, index) => (
                <AccordionItem key={index} value={`carrier-${index}`} className="border border-border bg-background rounded-lg px-6">
                  <AccordionTrigger className="text-xl font-semibold text-foreground hover:no-underline py-6">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};